module.exports = __webpack_public_path__ + "img/iphone.16ea7812.png";